// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1-FDc","rootCenter":"LoadMoreObserver_rootCenter__239ff","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__12wTN"};